<template>
    <div style="display: flex; flex-direction: column; overflow-y: scroll;">
        <div v-if="!isModify" style="display: flex; justify-content: flex-end;">
            <div :style="{ color: isEnableSave ? 'var(--color-main)' : '#d9d9d9' }" style="width: 60px; height: 50px; display: flex; justify-content: center; align-items: center; font-weight: 700;" @click="saveDetailSetting">완료</div>
        </div>
        <div @touchmove.stop="() => { }" @touchstart.stop="() => { }" :style="{ paddingBottom: '' }" style="flex: 1; padding: 0 20px; overflow: auto;">
            <div v-if="!isModify" style="text-align: center; margin-top: 30px;">
                <div style="font-weight: 700; font-size: 32px; margin-bottom: 16px;">멤버톡 세부설정</div>
                <div style="font-weight: 500; line-height: 23px;">멤버톡의 연령대와 모집 인원 및<br>소개 태그를 선택해주세요.</div>
            </div>
            <div :style="{ marginTop: isModify ? '16px' : '40px' }" style="margin-top: 40px;">
                <div v-if="settingType === SETTING_TYPE.AGE" style="margin-bottom: 32px;">
                    <div class="title">연령대</div>
                    <div style="display: grid; gap: 10px; grid-template-columns: 1fr 1fr;">
                        <div @click="setAge(each)" :class="changeBackColorAge(each) ? 'select' : ''" v-for="each, i in age" :key="i" style="font-weight: 500; display: flex; align-items: center; gap: 4px;" class="common_box">
                            <span>{{ each }}</span>
                            <img v-if="changeBackColorAge(each)" style="width: 14px;" :src="require('@/assets/img/check_black.png')" alt="">
                        </div>
                    </div>
                </div>
                <div v-else-if="settingType === SETTING_TYPE.TAG" style="margin-bottom: 32px;">
                    <div class="title">멤버톡 태그</div>
                    <div style="display: grid; gap: 10px; grid-template-columns: 1fr 1fr;">
                        <div @click="setTag(each)" :class="changeBackColorTag(each) ? 'select' : ''" v-for="each, i in memberTalkTag" :key="i" style="font-weight: 500; display: flex; align-items: center; gap: 4px;" class="common_box">
                            <span>{{ each }}</span>
                            <img v-if="changeBackColorTag(each)" style="width: 14px;" :src="require('@/assets/img/check_black.png')" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponseCode from '../../../ResponseCode'

const SETTING_TYPE = {
    AGE: 'age',
    TAG: 'tag'
}

// import CommonScrollSelector from '@/components/common/CommonScrollSelector'
export default {
    components: { },
    props: {
        isModify: {
            type: Boolean,
            default: false
        },
        memberTalkDetailInfo: {
            type: Object,
            default: () => { }
        },
        memberTalkIdx: {
            type: [Number, String],
            default: -1
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        settingType: {
            type: String,
            default: SETTING_TYPE.AGE
        }
    },
    name: 'MemberTalkDetailSetting',
    created() {
        this.saveDetailSetting = this.$Once(this.saveDetailSetting)
        if (this.isModify) {
            this.assignmentValue()
        }

        if(this.$GlobalStore.loginInfo().is_temp_coach == '1'){
            this.memberTalkTag = ['훈련', '레슨', '유소년', '여자축구']
        }

    },
    computed : {
        isEnableSave(){
            return !(this.memberTalkDetail.age.length === 0 || this.memberTalkDetail.maxCnt === 0 || this.memberTalkDetail.tag.length === 0 || !this.memberTalkDetail.placeInfo.id || Object.keys(this.selectFavoriteFormation).length === 0)
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.assignmentValue()
            }
        }
    },
    data() {
        return {
            age: ['10대', '20대', '30대', '40대', '50대', '무관'],
            memberTalkTag: ['매치 뛰기', '용병 모집', '조기축구', '친목', '국내축구', '해외축구', '팬클럽', '경기 직관', '레슨', '훈련', '유소년', '여자축구'],
            memberTalkDetail: {
                age: '',
                maxCnt: 0,
                tag: '',
                placeInfo: {}
            },
            SETTING_TYPE: SETTING_TYPE,
            maxCnt: [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 40, value: 40 },
                { label: 50, value: 50 },
                { label: 60, value: 60 },
                { label: 70, value: 70 },
            ],
            test: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            showScroll: false,
            selectFavoriteFormation: {}
        }
    },
    methods: {
        resetInfo() {
            this.memberTalkDetail.placeInfo = {};
        },
        detectRegionSelect(data) {
            this.memberTalkDetail.placeInfo = data;
        },
        async saveDetailSetting() {
            if (this.memberTalkDetail.age.length === 0 || this.memberTalkDetail.maxCnt === 0 || this.memberTalkDetail.tag.length === 0 || !this.memberTalkDetail.placeInfo.id || Object.keys(this.selectFavoriteFormation).length === 0) {
                this.$GlobalStore.showAlert('세부설정을 완료해주세요.')
                return
            }
            this.memberTalkDetail.age.sort((a, b) => {
                const numA = parseInt(a)
                const numB = parseInt(b)
                return numA - numB
            })
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            formData.append('mode', 'update')
            formData.append('join_tag', this.memberTalkDetail.tag.join(', '))
            formData.append('max_cnt', this.memberTalkDetail.maxCnt)
            formData.append('age', this.memberTalkDetail.age.join(', '))
            formData.append('join_idx', this.memberTalkIdx)
            formData.append('place_id', this.memberTalkDetail.placeInfo.id);
            formData.append('place_name', this.memberTalkDetail.placeInfo.name);
            formData.append('gps_latitude', this.memberTalkDetail.placeInfo.gps_latitude);
            formData.append('gps_longitude', this.memberTalkDetail.placeInfo.gps_longitude);
            formData.append('place_address', this.memberTalkDetail.placeInfo.address);
            formData.append('favorite_squad_type', this.selectFavoriteFormation.squad_type);

            const res = await this.$Axios.post('/api/join/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.hideProgress()
            } else {
                console.log(res.data.msg)
            }
        },
        emitModfiedMemberTalkDetail() {
            return this.memberTalkDetail
        },
        assignmentValue() {
            this.memberTalkDetail.age = []
            let resulAge = this.memberTalkDetailInfo.age.split(',')
            resulAge.forEach(item => {
                this.memberTalkDetail.age.push(item.trim())
            })
            this.memberTalkDetail.maxCnt = parseInt(this.memberTalkDetailInfo.max_cnt)
            let joinTag = this.memberTalkDetailInfo.join_tag.split(',')
            let replaceTag = []
            for (let i = 0; i < joinTag.length; i++) {
                let result = joinTag[i].replace(/#/g, '').trim()
                replaceTag.push(result)
            }
            joinTag = replaceTag
            this.memberTalkDetail.tag = joinTag
        },
        setAge(age) {
            this.memberTalkDetail.age = age
        },
        setShowScroll() {
            this.showScroll = true
        },
        setTag(tag) {
            this.memberTalkDetail.tag = tag
        },
        detectValueChange(selectedData) {
            this.memberTalkDetail.maxCnt = selectedData.value
        },
        selectMaxCnt() {
            this.showScroll = false
        },
        changeBackColorAge(age) {
            return this.memberTalkDetail.age.includes(age)
        },
        changeBackColorTag(tag) {
            return this.memberTalkDetail.tag.includes(tag)
        }
    }
}
</script>

<style scoped>
.common_box {
    border-radius: 12px;
    background-color: #f5f5f5;
    padding: 12px;
}

.title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 4px;
}

.select {
    background-color: var(--color-main);
}
</style>